/* eslint-disable no-restricted-imports */
import { DirectPayForType, DirectStrategyType } from '../../../../../data-layer/direct/types';
import { MIN_WEEKLY_LIMIT_VALUE } from '../../../../../routing/business/ContentPromotion/constants';
import { composeValidators } from '../../../../../utils/validators/compose';
import { makeIntegerValidator } from '../../../../../utils/validators/makeIntegerValidator';
import { makeMaxValueValidator } from '../../../../../utils/validators/makeMaxValueValidator';
import { makeMinValueValidator } from '../../../../../utils/validators/makeMinValueValidator';
import { makeRequiredValidator } from '../../../../../utils/validators/makeRequiredValidator';
import { DropdownOption } from '../ContentPromotionDropdown/types';

export const strategyOptions: DropdownOption[] = [
    { value: DirectStrategyType.MAX_CONVERSIONS, label: 'Максимум конверсий' },
    { value: DirectStrategyType.MAX_CLICKS, label: 'Максимум кликов' },
];

export const payForOptions: DropdownOption[] = [
    { value: DirectPayForType.CLICKS, label: 'За клики' },
    { value: DirectPayForType.CONVERSIONS, label: 'За конверсии' },
];

export const requireValidator = makeRequiredValidator<string>();

export const MAX_CRR_VALUE = 500;

export const crrValidator = composeValidators(
    makeRequiredValidator(),
    makeIntegerValidator(),
    makeMaxValueValidator(MAX_CRR_VALUE, 'Доля рекламных расходов не может быть выше 500%'),
);

export const weeklyLimitValidator = composeValidators(
    makeRequiredValidator(),
    makeIntegerValidator(),
    makeMinValueValidator(MIN_WEEKLY_LIMIT_VALUE, 'Недельный бюджет должен быть не меньше 300₽'),
);

export const showAverageCpcValidator = composeValidators(
    makeRequiredValidator(),
    makeIntegerValidator(),
);
